import type { ReactNode } from 'react';
import { useLocation, type To } from 'react-router-dom';
import { useEnabledClaimType } from '~/hooks/useEnabledClaimType';
import useIsCorsoAdmin from '~/hooks/useIsCorsoAdmin';
import { useDashboardParams } from './hooks/useDashboardParams';
import { offeredReportGroups } from './reports/groups';

/** The sidebar's links to each dashboard on offer, rendered only while one is open. */
export const DashboardSubLinks = ({
  children,
}: {
  children: (links: { name: string; to: To }[]) => ReactNode;
}) => {
  const { organization } = useDashboardParams();
  const enabled = useEnabledClaimType();
  const isCorsoAdmin = useIsCorsoAdmin();
  // moving between dashboards keeps the date and filters chosen
  const { search } = useLocation();

  return children([
    // the home reads one store, so it isn't offered while an organization is chosen
    ...(isCorsoAdmin && organization === null
      ? [
          {
            name: 'Home',
            to: { pathname: 'analytics/dashboards/home', search },
          },
        ]
      : []),
    ...(
      offeredReportGroups(enabled, organization !== null, isCorsoAdmin) ?? []
    ).map(({ key, label }) => ({
      name: label,
      to: { pathname: `analytics/dashboards/${key}`, search },
    })),
  ]);
};
